import { useParams } from "react-router-dom";

export const useUrlMappingEditPageParams = () => {
  const { siteSlug = "", urlMappingId = "" } = useParams();

  return { siteSlug, urlMappingId: decodeURIComponent(urlMappingId) };
};
